import { z } from "zod";

export const CrmFieldMappingsSchema = z.object({
  status: z.string().min(1).optional(),
  bio: z.string().min(1).optional(),
});

export type CrmFieldMappings = z.infer<typeof CrmFieldMappingsSchema>;

export const CrmIntegrationSwoogoSchema = z.object({
  type: z.literal("swoogo"),
  externalId: z.string().min(1),
  verificationHash: z.string().min(1),
  fieldMappings: CrmFieldMappingsSchema.nullable().optional(),
  removalStatusValues: z.array(z.string().min(1)).min(1).nullable().optional(),
  excludedExternalIds: z.array(z.string().min(1)).min(1).nullable().optional(),
});
export const CrmIntegrationSchema = z.discriminatedUnion("type", [
  CrmIntegrationSwoogoSchema,
]);

export type CrmIntegration = z.infer<typeof CrmIntegrationSchema>;

export const CrmIntegrationSwoogoViewSchema = CrmIntegrationSwoogoSchema.omit({
  verificationHash: true,
});
export const CrmIntegrationViewUnionSchema = z.discriminatedUnion("type", [
  CrmIntegrationSwoogoViewSchema,
]);
